import clsx from 'clsx';
import React, { type FC, type PropsWithChildren } from 'react';

import type { TextSizeType } from '../utils';

type PreTagProps = {
  hasTitle: boolean;
  textSize: TextSizeType;
  className?: string;
};

export const PreTag: FC<PropsWithChildren<PreTagProps>> = ({
  hasTitle,
  children,
  textSize,
  className,
}) => {
  const classes = clsx(
    [
      'codeblock-pre',
      'px-f2',
      'bg-negative',
      'whitespace-pre-wrap',
      'break-all',
      'overflow-auto',
      'scrollbar-hide',
      'w-full',
    ],
    hasTitle && 'pb-f2',
    !hasTitle && 'py-f2',
    `text-${textSize}`,
    className
  );
  return <pre className={classes}>{children}</pre>;
};
